module.exports = "https://coursera_assets.s3.amazonaws.com/images/520e35171152d690b99a51559ef33a31.png";